import React from 'react'
import './footer.css'


function Footer() {
    return (
        <div className='footer'>
           Made by Nipuna Peiris
        </div>
    )
}

export default Footer
